import React from "react";
import { useTranslation } from "react-i18next";

import { Input, TextArea, Checkbox1, Radio } from "components";

import {
  WrapperTitleInputTextarea,
  RadioStyled,
  WrapperQuestionDetail,
  Label,
  QuestionName,
  QuestionExplanation,
  WrapperQuestion,
  QuestionDraftTitle,
  QuestionIndividualAnswerBody,
  DescriptionStyled2,
  QuestionDraftTitleLeft,
  QuestionDraftTitleRight,
} from "./Questions.style";
import { IQuestionnaire } from "models/questionnaires/questionnairesDetail";
import { LinkedIcon } from "icons";
import { localStorageHelper } from "utils";

const Question = ({ question, index, questionnaires }: any) => {
  const { t }: any = useTranslation("translation", { keyPrefix: "questions" });

  const dataList = question.questionnaire_answers.map((ans: any) => {
    return {
      key: ans.id,
      value: ans.id,
      name: ans.answer_text,
    };
  });

  const items: any = {
    radio: (
      <RadioStyled>
        <Radio list={dataList} />
      </RadioStyled>
    ),
    checkbox: <Checkbox1 list={dataList} />,
    text: (
      <React.Fragment>
        <Input
          height={40}
          fsLabel={16}
          disabled
          marginForm="0 0 8px"
          value={question?.questionnaire_answers[0]?.answer_text || ""}
        />
        <WrapperTitleInputTextarea>
          {t("text-description-formula")}
        </WrapperTitleInputTextarea>
      </React.Fragment>
    ),
    multiLine: (
      <React.Fragment>
        <TextArea
          height={"120px"}
          fsLabel={16}
          disabled
          value={question?.questionnaire_answers[0]?.answer_text || ""}
        />
        <WrapperTitleInputTextarea>
          {t("text-description-formula-textarea")}
        </WrapperTitleInputTextarea>
      </React.Fragment>
    ),
    pulldown: (
      <div style={{ marginTop: "24px" }}>
        {question.questionnaire_answers.map((ans: any) => {
          return (
            <Input
              key={ans.id}
              value={ans.answer_text}
              height={31}
              fsLabel={16}
              width={243}
              marginForm="10px 0px"
              disabled
            />
          );
        })}
      </div>
    ),
  };

  const handleRenderItem = (answerType: string) => {
    return items[answerType];
  };

  const handleTitleRight = (currentQuestion: any) => {
    const currentLanguage = localStorageHelper.getItem("i18nextLng");
    let text = "";

    if (questionnaires.questionnaire_questions) {
      questionnaires.questionnaire_questions
        .filter((qs: any) => qs.is_answer_link_question)
        .map((item: any) => {
          if (item.questionnaire_answers.length) {
            item.questionnaire_answers.forEach((as: any) => {
              if (
                as?.link_questionnaire_question &&
                Object.keys(as.link_questionnaire_question).length &&
                as.link_questionnaire_question.question_position ===
                  currentQuestion.question_position
              ) {
                text =
                  currentLanguage === "ja"
                    ? `質問${item.question_position}「${as.answer_text}」から`
                    : `From question ${item.question_position} "${as.answer_text}"`;
              }
            });
          }
        });
    }

    return text;
  };

  return (
    <WrapperQuestion>
      {/* <QuestionDraftTitle>{t("question") + index}</QuestionDraftTitle> */}
      <QuestionDraftTitle
        bg={question?.is_link_question ? "#EBC300" : "#2F8CAE"}
      >
        <QuestionDraftTitleLeft>
          {question?.is_link_question && <LinkedIcon />}{" "}
          <div style={{ width: "max-content" }}>
            {t("question") + `${index}` + (question?.copy_idx || "")}
          </div>
        </QuestionDraftTitleLeft>

        {question?.is_link_question && (
          <QuestionDraftTitleRight>
            {handleTitleRight(question)}
          </QuestionDraftTitleRight>
        )}
      </QuestionDraftTitle>

      <QuestionIndividualAnswerBody>
        {question.question_content && <div>{question.question_content}</div>}
        {question.question_summary && (
          <DescriptionStyled2>{question.question_summary}</DescriptionStyled2>
        )}
        {handleRenderItem(question.answer_type)}
      </QuestionIndividualAnswerBody>
    </WrapperQuestion>
  );
};

const Questionnaire = ({
  questionnaires,
}: {
  questionnaires: IQuestionnaire;
}) => {
  const { t }: any = useTranslation("translation", { keyPrefix: "questions" });

  return (
    <React.Fragment>
      <WrapperQuestionDetail>
        <Label>{t("questionnaire-name")}</Label>
        <QuestionName>{questionnaires.title}</QuestionName>
        <Label>{t("questionnaire-explanation")}</Label>
        <QuestionExplanation>{questionnaires.explanation}</QuestionExplanation>
      </WrapperQuestionDetail>

      {(questionnaires?.questionnaire_questions || []).map((question, idx) => {
        return (
          <Question
            key={question.id}
            question={question}
            index={idx + 1}
            questionnaires={questionnaires}
          />
        );
      })}
    </React.Fragment>
  );
};

export default Questionnaire;
